const styles = theme => ({
  container: {
    padding: theme.spacing(4),
  },
  header: {
    fontFamily: 'Roboto-Bold',
    fontSize: 32,
    paddingBottom: theme.spacing(4),

    [theme.breakpoints.down('sm')]: {
      fontSize: 26,
    }
  },
  card: {
    background: '#fff',
    borderRadius: 16,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    overflow: 'hidden',
    height: '100%'
  },
  cardShadow: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    '& > div': {
      padding: theme.spacing(3),
    },
    '& .blue-card': {
      flex: 1,
      background: 'rgba(136, 201, 241, 0.12)',
      borderTop: '5px solid #88C9F1',
      fontSize: 12,
      '& .fa-check': {
        fontSize: 16,
      }
    },

    '&:hover': {
      cursor: 'pointer',
      boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.10), 0 1px 3px 1px rgba(0, 0, 0, 0.10)',
    }
  },
  cardHeader: {
    fontSize: 18,
    fontFamily: 'Roboto-Bold'
  },
  blueBtn: {
    color: '#005B82'
  },
  btnSmall: {
    fontSize: 15,
    lineHeight: '1rem',
    padding: 5
  },
  btnArrow: {
    position: 'absolute',
    right: -10,
    top: -10,
  },
  bigIcon: {
    fontSize: 22,
  },
  btnGrey: {
    color: '#64748B',
  },
  newsHeadline: {
    fontSize: 18,
    fontFamily: 'Roboto-Bold'
  },
  newsDescription: {
    fontSize: 15,
    minHeight: 50,
  },
  newsImage: {
    height: 160,
    '& img': {
      height: '100%',
      width: '100%',
      objectFit: 'cover'
    }
  },
  newsDetailsBtn: {
    fontSize: 15,
    color: '#005B82',
    fontFamily: 'Roboto-Bold'
  },
  productItem: {
    paddingTop: 12,
    paddingBottom: 12,

    borderTop: '1px solid #CBD5E1',
    '&:last-child': {
      borderBottom: '1px solid #CBD5E1'
    },
    '&:hover': {
      cursor: 'pointer',
      background: 'rgba(0,91, 130, 0.12)'
    },
    '&.active $productIcon': {
      color: '#fff',
      backgroundColor: '#005B82',
    }
  },
  productIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 22,
    textAlign: 'center',
    width: 40,
    height: 40,
    borderRadius: 24,
    backgroundColor: '#F1F5F9',
  },
  productTitle: {
    fontSize: 18,
    fontFamily: 'Roboto-Bold'
  },
  productDescription: {
    fontSize: 12,
    color: 'rgba(15, 23, 42, 0.60)'
  },
  productImage: {
    position: 'relative',
    height: '100%',
    width: 'calc(100% + 24px)',

    '& img': {
      height: 'calc(100% + 32px)',
      width: '100%',
      objectFit: 'cover',
    },

    [theme.breakpoints.up('sm')]: {
      top: -16,
    },

    [theme.breakpoints.down('sm')]: {
      height: 140,
      width: 'calc(100% + 48px)',
      left: -24,
      bottom: -16,
    }
  },
  cardLogo: {
    height: 64,
  },
  filesContainer: {
    height: 'calc(100% + 16px)',
    [theme.breakpoints.up('md')]: {
      maxWidth: 380
    }
  },
  fileLink: {
    fontSize: 15,
    fontFamily: 'Roboto-Bold',
    textDecoration: 'underline'
  },
  serviceImage: {
    textAlign: 'center',
    '& svg': {
      maxWidth: '100%',
    }
  },
  servicePointHeader: {
    fontSize: 15,
    fontFamily: 'Roboto-Bold',
  },
  servicePointDescription: {
    fontSize: 12,
  },
  serviceCheckIcon: {
    fontSize: 32,
    color: '#4CAF50'
  },
  contactRole: {
    fontSize: 12,
    color: 'rgba(15, 23, 42, 0.6)'
  },
  contactHeadline: {
    fontSize: 18
  },
  contactIcon: {
    width: 74,
    height: 74,
    borderRadius: 42,
    backgroundColor: '#F1F5F9',
    overflow: 'hidden',
    '& img': {
      height: '100%'
    }
  },
  contactsDivider: {
    background: '#CBD5E1',
    height: 1,
  },
  contactLink: {
    fontSize: 15,
    fontFamily: 'Roboto-Bold',
    textDecoration: 'underline',
    color: '#005B82',
  },
  dialogPaper: {
    borderRadius: 16,
  },
  dialogTitle: {
    backgroundColor: 'rgba(100, 116, 139, 0.12)',
    fontSize: 18,

    '& .MuiIconButton-root': {
      color: '#005B82',
      '&:hover': {
        backgroundColor: 'rgba(0, 91, 130, 0.12)'
      }
    }
  },
  dialogContentBlock: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  contactDialogBtn: {
    color: '#005B82',
    borderColor: '#CBD5E1',
    "&:hover": {
      borderColor: '#CBD5E1',
      backgroundColor: 'rgba(0, 91, 130, 0.12)'
    }
  },
  dialogSuccessBtn: {
    background: '#28B9D7',
  }
});

export default styles;